/**
 * Native help games — 在 host 內原生渲染賠付 / 規則 / 歷史頁，
 * 不走 shared-web iframe。
 *
 * **2026-07 重構：白名單不再手寫**，由 registry 的 `REGISTERED_GAME_IDS` 派生
 * （= `src/games/<gameId>/content.ts` 存在即入列，glob build-time 靜態掃出、
 * 不觸發任何 import）。新增遊戲建好 content.ts 就自動進白名單，`pnpm new:game`
 * 不再需要插入本檔。
 *
 * 語意不變：已註冊 = 該遊戲走 host 原生管道；未註冊的 gameId 走 placeholder
 * 流程（見 src/games/_placeholder.ts）。未來若要「檔案存在但暫不上原生」的例外，
 * 在 isNativeHelpGame 內加一個 exclusion Set 過濾即可。
 *
 * ⚠️ 刻意**不** re-export 一個 `NATIVE_HELP_GAMES` 常數：registry.ts 靜態 import 了
 * 共用 modal 元件、那些元件又 import registry，本檔加進來後屬於同一個 ESM 循環。
 * 在 module init 當下讀 `REGISTERED_GAME_IDS` 可能撞 TDZ；改成 **呼叫時**才讀
 * （函式 body 在所有模組初始化完成後才執行）就完全免疫。
 */

import { isPlaceholderResolved } from '../games/_placeholder'
import { REGISTERED_GAME_IDS } from '../games/registry'

/**
 * 屬於 native help 範疇的 modal key（balance 不在此列 —— 那是另一條獨立的 native 流程）。
 */
export const NATIVE_HELP_KEYS: ReadonlySet<string> = new Set(['paytable', 'rules', 'history'])

export const isNativeHelpGame = (gameId: string | null | undefined): boolean => {
  if (!gameId) return false
  if (REGISTERED_GAME_IDS.has(gameId.toLowerCase())) return true
  // 已解析為 placeholder 的未建立遊戲（fetchGameCode 後台查無後標記）：help modal
  // 走 host 原生空殼，而非破掉的 shared-web iframe。詳見 src/games/_placeholder.ts
  return isPlaceholderResolved(gameId)
}

export const isNativeHelpKey = (modalKey: string): boolean => {
  return NATIVE_HELP_KEYS.has(modalKey)
}

export const isNativeHelp = (modalKey: string, gameId: string | null | undefined): boolean => {
  return isNativeHelpKey(modalKey) && isNativeHelpGame(gameId)
}
